import React from 'react';
import { sendRedefinitionMail } from '../../../api/sessionAPI';
import {
    Box, Button, Divider, TextField, Typography,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import LockResetIcon from '@mui/icons-material/LockReset';

const BG_SECTION     = '#1c1c24';
const BG_CARD        = '#24242e';
const BRAND_RED      = '#c0392b';
const TEXT_PRIMARY   = '#f4f4f6';
const TEXT_SECONDARY = 'rgba(244,244,246,0.65)';
const BORDER_SUBTLE  = '1px solid rgba(255,255,255,0.08)';

export function AccessibilityUserConfigForm() {
    const handleClickSendRedefinitionMail = async () => {
        await sendRedefinitionMail();
    };

    return (
        <Box sx={{ bgcolor: BG_SECTION, borderRadius: '10px', border: BORDER_SUBTLE, p: { xs: 2, sm: 3 } }}>
            <Typography fontWeight={600} color={TEXT_PRIMARY} mb={{ xs: 2, sm: 3 }} sx={{ fontSize: { xs: '0.95rem', sm: '1.1rem', md: '1.25rem' } }}>
                Accessibility
            </Typography>

            {/* Language row */}
            <Box
                sx={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    bgcolor: BG_CARD, borderRadius: '8px', p: 2, mb: 1.5,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <LanguageIcon sx={{ color: TEXT_SECONDARY, fontSize: 20 }} />
                    <Box>
                        <Typography variant='body2' fontWeight={500} color={TEXT_PRIMARY}>Language</Typography>
                        <Typography variant='caption' color={TEXT_SECONDARY}>Interface language (coming soon)</Typography>
                    </Box>
                </Box>
                <TextField
                    disabled
                    value='English'
                    size='small'
                    sx={{
                        width: 130,
                        '& .MuiOutlinedInput-root': {
                            color: TEXT_SECONDARY,
                            bgcolor: BG_SECTION,
                            '& fieldset': { borderColor: 'rgba(255,255,255,0.1)' },
                        },
                        '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: TEXT_SECONDARY },
                    }}
                />
            </Box>

            <Divider sx={{ borderColor: 'rgba(255,255,255,0.06)', my: 2 }} />

            {/* Password row */}
            <Box
                sx={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    bgcolor: BG_CARD, borderRadius: '8px', p: 2,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <LockResetIcon sx={{ color: TEXT_SECONDARY, fontSize: 20 }} />
                    <Box>
                        <Typography variant='body2' fontWeight={500} color={TEXT_PRIMARY}>Password</Typography>
                        <Typography variant='caption' color={TEXT_SECONDARY}>Send a reset link to your email</Typography>
                    </Box>
                </Box>
                <Button
                    variant='outlined'
                    size='small'
                    onClick={handleClickSendRedefinitionMail}
                    sx={{
                        borderColor: 'rgba(255,255,255,0.2)',
                        color: TEXT_SECONDARY,
                        textTransform: 'none',
                        '&:hover': { borderColor: BRAND_RED, color: TEXT_PRIMARY, bgcolor: 'rgba(192,57,43,0.08)' },
                    }}
                >
                    Reset Password
                </Button>
            </Box>
        </Box>
    );
}
